module.exports = __webpack_public_path__ + "img/empty.7fc3015a.png";